export interface IBranch {
  workspace: String | Object
  type: String
  name: String
  taxNumber: String
  website: String
  address: String
  logoUrl: String
  status: Number
  workday: Number
  currency: String
}
const rulesBranch = {
  name: 'required',
  taxNumber: 'required',
  website: 'required',
  address: 'required'
}

const initBranch = {
  workspace: '',
  type: '',
  name: '',
  taxNumber: '',
  website: '',
  address: '',
  logoUrl: '',
  status: 0,
  workday: 0,
  currency: ''
}
export interface ICompanyGroup {
  group: string
  name: string
}
export interface ICompanyUser {
  workspace: String | Object
  user: String
  status: Number
  company: String
  group: ICompanyGroup
  fullName: String
  address: String
  contactEmail: String
  jobTitle: String
}
const rulesCompanyUser = {
  fullName: 'required',
  address: 'required',
  contactEmail: 'required',
  jobTitle: 'required',
  status: 'required'
}

const initCompanyUser = {
  fullName: '',
  address: '',
  contactEmail: '',
  group: '',
  jobTitle: '',
  status: '',
  code: ''
}

export default {
  rulesBranch,
  initBranch,
  rulesCompanyUser,
  initCompanyUser
}
